import axios from 'axios';
import qs from "qs";

export const getPaymentMethods = async () => {
    const result = await ajaxCall({action: "payment_methods"})

    if (result) {
        return result;
    }

    try {
        const {data} = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/payment/methods`,
        );

        return data;
    } catch (e) {

    }
    return [];
};

export const postPaymentRequest = async (payload) => {
    const result = await ajaxCall({action: "payment_post", payload})
    if (result) {
        return result;
    }

    try {
        const {data} = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/payment/pay`,
            payload
        );

        return data;
    } catch (e) {

    }
    return [];
}

export const getPaymentRequest = async (paymentId) => {
    const payload= {
        payment_id:paymentId
    };

    const result = await ajaxCall({action: "payment_get",payload})
    if (result) {
        return result;
    }

    try {
        const {data} = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/payment/get`,
            payload
        );

        return data;
    } catch (e) {

    }
    return [];
}

async function ajaxCall(request) {
    const reactAppData = window.payment || {}
    const {ajax_url} = reactAppData

    if (ajax_url) {
        try {
            const {data} = await axios.post(ajax_url, qs.stringify(request));

            return data;
        } catch (e) {
            console.log(e);
        }
    }
}
